<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import activity_type from "../../../helpers/list/activity_type";
import obtain_approval from "../../../helpers/list/obtain_approval";

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      name_volunteer_team: "",
      date_program: "",
      activity_type_id: "",
      another_activity_type: "",
      obtain_approval_id: "",
      expected_number_attendees: "",
      location_program: "",
      duration_program: "",
      program_goal: "",
      needs: "",
      characters_attending: "",
      characters_implement_program: "",
      challenges: "",
      number_members: "",
      description: "",
      notes: "",

      //lists
      list_activity_type: activity_type,
      list_obtain_approval: obtain_approval,
    };
  },
  validations: {
    name_volunteer_team: { required, minLength: minLength(2), maxLength: maxLength(50) },
    activity_type_id: { required },
    another_activity_type: {
      required: requiredIf(function () {
        return this.getActivityType();
      }),
      minLength: minLength(2),
      maxLength: maxLength(50),
    },
    date_program: { required },
    obtain_approval_id: { required },
    expected_number_attendees: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(500),
    },
    location_program: { required, minLength: minLength(2), maxLength: maxLength(100) },
    duration_program: { required, minLength: minLength(2), maxLength: maxLength(100) },
    program_goal: { required, minLength: minLength(4), maxLength: maxLength(500) },
    needs: { required, minLength: minLength(4), maxLength: maxLength(500) },
    characters_attending: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    characters_implement_program: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(500),
    },
    challenges: { required, minLength: minLength(4), maxLength: maxLength(500) },
    number_members: { required, minLength: minLength(1), maxLength: maxLength(500) },
    description: { required, minLength: minLength(4), maxLength: maxLength(500) },
    notes: { required, minLength: minLength(4), maxLength: maxLength(500) },
    form: [
      "name_volunteer_team",
      "activity_type_id",
      "another_activity_type",
      "date_program",
      "obtain_approval_id",
      "expected_number_attendees",
      "location_program",
      "duration_program",
      "program_goal",
      "needs",
      "characters_attending",
      "characters_implement_program",
      "challenges",
      "number_members",
      "description",
      "notes",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    // getActivityType
    getActivityType() {
      return this.activity_type_id == "17";
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">معلومات البرنامج او النشاط</h5></div>
          <b-form-group
            class="col-md-12 mb-3"
            label="إسم الفريق التطوعي  أو المنظمة التي تنظم هذا النشاط
( في حال لم يكن هناك إسم لفريق او منظمة ,اكتب لا يوجد ) ."
            label-for="name_volunteer_team"
          >
            <b-form-input
              id="name_volunteer_team"
              type="text"
              placeholder="ادخل اسم الفريق التطوعي"
              v-model="name_volunteer_team"
              :class="{ 'is-invalid': $v.name_volunteer_team.$error }"
            ></b-form-input>
            <div v-if="$v.name_volunteer_team.$error" class="invalid-feedback">
              <span v-if="!$v.name_volunteer_team.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name_volunteer_team.minLength"
                >يجب أن يتكون هذا الحقل من حرفين على الأقل</span
              >
              <span v-if="!$v.name_volunteer_team.maxLength"
                >يجب أن يتكون هذا الحقل من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label=" نوع البرنامج او النشاط : "
            label-for="activity_type_id"
          >
            <select
              class="form-control form-select"
              id="activity_type_id"
              v-model="activity_type_id"
              :class="{ 'is-invalid': $v.activity_type_id.$error }"
            >
              <option value="">اختر نوع البرنامج او النشاط</option>
              <option
                v-for="activity_type in list_activity_type"
                :value="activity_type.id"
                :key="activity_type.id"
              >
                {{ activity_type.name }}
              </option>
            </select>
            <div v-if="$v.activity_type_id.$error" class="invalid-feedback">
              <span v-if="!$v.activity_type_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label="تاريخ اقامة البرنامج : "
            label-for="date_program"
          >
            <date-picker
              id="date_program"
              type="date"
              lang="ar"
              value-type="DD-MM-YYYY"
              format="DD-MM-YYYY"
              placeholder="اختر تاريخ اقامة البرنامج"
              v-model="date_program"
              :class="{ 'is-invalid': $v.date_program.$error }"
            ></date-picker>
            <div v-if="$v.date_program.$error" class="invalid-feedback">
              <span v-if="!$v.date_program.required">هذا الحقل الزامي </span>
            </div>
          </b-form-group>
        </div>
        <div class="row" v-if="getActivityType()">
          <b-form-group
            class="col-md-12 mb-3"
            label="ادخل عنوان البرنامج او النشاط :"
            label-for="another_activity_type"
          >
            <b-form-input
              id="another_activity_type"
              type="text"
              placeholder="ادخل عنوان البرنامج او النشاط"
              v-model="another_activity_type"
              :class="{ 'is-invalid': $v.another_activity_type.$error }"
            ></b-form-input>
            <div v-if="$v.another_activity_type.$error" class="invalid-feedback">
              <span v-if="!$v.another_activity_type.required">هذا الحقل الزامي</span>
              <span v-if="!$v.another_activity_type.minLength"
                >يجب أن تتكون الجامعة من 4 احرف على الأقل</span
              >
              <span v-if="!$v.another_activity_type.maxLength"
                >يجب أن تتكون الجامعة من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>

        <div class="row">
          <b-form-group
            class="col-md-12 mb-3"
            label=" هل حصلت على موافقة الجهة الرسمية المعنية كموافقة الجامعة او مسؤول المنطقة ؟"
            label-for="obtain_approval_id"
          >
            <select
              class="form-control form-select"
              id="obtain_approval_id"
              v-model="obtain_approval_id"
              :class="{ 'is-invalid': $v.obtain_approval_id.$error }"
            >
              <option value="">اختر الاجابة</option>
              <option
                v-for="obtain_approval in list_obtain_approval"
                :value="obtain_approval.id"
                :key="obtain_approval.id"
              >
                {{ obtain_approval.name }}
              </option>
            </select>
            <div v-if="$v.obtain_approval_id.$error" class="invalid-feedback">
              <span v-if="!$v.obtain_approval_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="ما هو العدد المتوقع للفئة المستهدفة ؟
  (مثلا اذا كان مهرجان فما هو العدد المتوقع لحضور المهرجان او العدد المتوقع للمشاركة بحملة تبرع بالدم وهكذا)"
            label-for="expected_number_attendees"
          >
            <b-form-input
              id="expected_number_attendees"
              type="text"
              placeholder="ادخل العدد المتوقع"
              v-model="expected_number_attendees"
              :class="{ 'is-invalid': $v.expected_number_attendees.$error }"
            ></b-form-input>
            <div v-if="$v.expected_number_attendees.$error" class="invalid-feedback">
              <span v-if="!$v.expected_number_attendees.required">هذا الحقل الزامي</span>
              <span v-if="!$v.expected_number_attendees.minLength"
                >يجب أن يتكون العدد المتوقع من حرف واحد على الأقل</span
              >
              <span v-if="!$v.expected_number_attendees.maxLength"
                >يجب أن يتكون العدد المتوقع من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label="مكان اقامة البرنامج : "
            label-for="location_program"
          >
            <b-form-input
              id="location_program"
              type="text"
              placeholder="ادخل مكان اقامة البرنامج"
              v-model="location_program"
              :class="{ 'is-invalid': $v.location_program.$error }"
            ></b-form-input>
            <div v-if="$v.location_program.$error" class="invalid-feedback">
              <span v-if="!$v.location_program.required">هذا الحقل الزامي</span>
              <span v-if="!$v.location_program.minLength"
                >يجب أن يتكون مكان اقامة البرنامج من حرفين على الأقل</span
              >
              <span v-if="!$v.location_program.maxLength"
                >يجب أن يتكون مكان اقامة البرنامج من 100 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label="مدة اقامة البرنامج ( كم ساعة او كم يوم يستغرق البرنامج او الحملة ) . "
            label-for="duration_program"
          >
            <b-form-input
              id="duration_program"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="duration_program"
              :class="{ 'is-invalid': $v.duration_program.$error }"
            ></b-form-input>
            <div v-if="$v.duration_program.$error" class="invalid-feedback">
              <span v-if="!$v.duration_program.required">هذا الحقل الزامي</span>
              <span v-if="!$v.duration_program.minLength"
                >يجب أن يتكون الحقل من حرفين على الأقل</span
              >
              <span v-if="!$v.duration_program.maxLength"
                >يجب أن يتكون الحقل من 100 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-12 mb-3"
            label="ما هي أهداف البرنامج او النشاط ؟"
            label-for="program_goal"
          >
            <b-form-textarea
              id="program_goal"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="program_goal"
              :class="{ 'is-invalid': $v.program_goal.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.program_goal.$error" class="invalid-feedback">
              <span v-if="!$v.program_goal.required">هذا الحقل الزامي</span>
              <span v-if="!$v.program_goal.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.program_goal.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="ما هي الامور التي تحتاجها من الحشد ؟
(يرجى كتابة المتطلبات على شكل نقاط واي متطلبات غير مرتبة على شكل نقاط ستهمل)"
            label-for="needs"
          >
            <b-form-textarea
              id="needs"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="needs"
              :class="{ 'is-invalid': $v.needs.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.needs.$error" class="invalid-feedback">
              <span v-if="!$v.needs.required">هذا الحقل الزامي</span>
              <span v-if="!$v.needs.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.needs.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="من هي الشخصيات الرسمية التي ستحضر البرنامج ؟"
            label-for="characters_attending"
          >
            <b-form-textarea
              id="characters_attending"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="characters_attending"
              :class="{ 'is-invalid': $v.characters_attending.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.characters_attending.$error" class="invalid-feedback">
              <span v-if="!$v.characters_attending.required">هذا الحقل الزامي</span>
              <span v-if="!$v.characters_attending.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.characters_attending.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="من هي الشخصيات التي ستُحيي البرنامج ؟
 ( مثلا اذا كان مهرجان, فمن هم الشعراء و الشخصيات الذين يصعدون المنصة؟ وكذلك من المتحدث في الندوة؟ ومن هو المدرب اذا كان البرنامج تدريبي وهكذا..) .
"
            label-for="characters_implement_program"
          >
            <b-form-textarea
              id="characters_implement_program"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="characters_implement_program"
              :class="{ 'is-invalid': $v.characters_implement_program.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.characters_implement_program.$error" class="invalid-feedback">
              <span v-if="!$v.characters_implement_program.required"
                >هذا الحقل الزامي</span
              >
              <span v-if="!$v.characters_implement_program.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.characters_implement_program.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="ما هي التحديات التي تواجهكم لانجاح البرنامج ؟
 (تحدث عن اهم المعرقلات و المشاكل التي قد تواجهكم لكي نضع لها حلول مسبقة) .
"
            label-for="challenges"
          >
            <b-form-textarea
              id="challenges"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="challenges"
              :class="{ 'is-invalid': $v.challenges.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.challenges.$error" class="invalid-feedback">
              <span v-if="!$v.challenges.required">هذا الحقل الزامي</span>
              <span v-if="!$v.challenges.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.challenges.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="عدد اعضاء الفريق القائم على تنفيذ البرنامج ؟"
            label-for="number_members"
          >
            <b-form-textarea
              id="number_members"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="number_members"
              :class="{ 'is-invalid': $v.number_members.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.number_members.$error" class="invalid-feedback">
              <span v-if="!$v.number_members.required">هذا الحقل الزامي</span>
              <span v-if="!$v.number_members.minLength"
                >يجب أن يتكون هذا الحقل من حرف واحد على الأقل</span
              >
              <span v-if="!$v.number_members.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="وصف او شرح البرنامج ؟"
            label-for="description"
          >
            <b-form-textarea
              id="description"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="description"
              :class="{ 'is-invalid': $v.description.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.description.$error" class="invalid-feedback">
              <span v-if="!$v.description.required">هذا الحقل الزامي</span>
              <span v-if="!$v.description.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.description.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="ملاحظاتكم :
يرجى كتابة اي ملاحظات او مقترحات تسهل علينا خدمتكم .
"
            label-for="notes"
          >
            <b-form-textarea
              id="notes"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="notes"
              :class="{ 'is-invalid': $v.notes.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.notes.$error" class="invalid-feedback">
              <span v-if="!$v.notes.required">هذا الحقل الزامي</span>
              <span v-if="!$v.notes.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.notes.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
